import { initApi, makePlatformAdapter, makeStorageAdapter } from "@stryker/core";
import { env } from "../env";

const baseURL = env.VITE_BASE_API_URL ?? "";

if (!baseURL) {
  console.warn("VITE_BASE_API_URL is not set; API requests may fail.");
}

initApi({
  baseURL,
  storage: makeStorageAdapter({
    async getAccessToken() {
      return localStorage.getItem("jwt_access_token");
    },
    async getRefreshToken() {
      return localStorage.getItem("jwt_refresh_token");
    },
    async setAccessToken(token: string) {
      localStorage.setItem("jwt_access_token", token);
    },
    async setRefreshToken(token: string) {
      localStorage.setItem("jwt_refresh_token", token);
    },
    async clear() {
      localStorage.clear();
    },
  }),
  platform: makePlatformAdapter({
    redirectToLogin: () => {
      if (!window.location.href.includes("/login")) {
        window.location.href = `${window.location.origin}/login`;
      }
    },
    restartApp: () => window.location.reload(),
  }),
});
